(()=>{
  const init=()=>document.querySelectorAll('[data-ia-orbit]').forEach(root=>{
    if(root.dataset.ready)return;
    root.dataset.ready='true';
    const field=root.querySelector('.ia-orbit-field'),slides=[...root.querySelectorAll('[data-orbit-slide]')],satellites=[...root.querySelectorAll('[data-orbit-satellite]')],current=root.querySelector('[data-orbit-current]');
    if(!slides.length)return;
    const reduce=matchMedia('(prefers-reduced-motion: reduce)'),clamp=n=>Math.min(1,Math.max(0,n));
    let active=0,raf=0,lastProgress=-1;
    const select=i=>{active=(i+slides.length)%slides.length;slides.forEach((s,j)=>{s.classList.toggle('is-active',j===active);s.setAttribute('aria-hidden',String(j!==active));});satellites.forEach((s,j)=>s.setAttribute('aria-pressed',String(j===active)));current.textContent=String(active+1).padStart(2,'0');};
    const render=()=>{
      raf=0;
      const box=root.getBoundingClientRect();
      if(box.bottom<0||box.top>innerHeight)return;
      const p=reduce.matches?0:clamp((76-box.top)/Math.max(1,root.offsetHeight-root.querySelector('.ia-orbit-sticky').offsetHeight));
      if(Math.abs(p-lastProgress)>.0001){select(Math.min(slides.length-1,Math.floor(p*slides.length)));lastProgress=p;}
      const w=field.clientWidth,h=field.clientHeight,mobile=w<750;
      satellites.forEach((s,i)=>{const angle=(-108+p*270+i*360/slides.length)*Math.PI/180,depth=(Math.sin(angle)+1)/2,x=Math.cos(angle)*w*(mobile?.43:.38),y=Math.sin(angle)*h*.39;s.style.transform=`translate(-50%,-50%) translate3d(${x}px,${y}px,0) scale(${.72+depth*.2})`;s.style.opacity=i===active?'.32':String(.68+depth*.32);});
      root.querySelector('.ia-orbit-ring').style.transform=`translate(-50%,-50%) rotate(${-16+p*50}deg)`;
    };
    const request=()=>{if(!raf)raf=requestAnimationFrame(render);};
    satellites.forEach((s,i)=>s.addEventListener('click',()=>select(i)));
    root.querySelector('[data-orbit-prev]').addEventListener('click',()=>select(active-1));
    root.querySelector('[data-orbit-next]').addEventListener('click',()=>select(active+1));
    if(!reduce.matches)root.classList.add('is-enhanced');
    window.addEventListener('scroll',request,{passive:true});window.addEventListener('resize',request,{passive:true});
    reduce.addEventListener('change',()=>{root.classList.toggle('is-enhanced',!reduce.matches);request();});
    select(0);request();
  });
  init();document.addEventListener('shopify:section:load',init);
})();
